<template>
  <div class="fac">
    <seleccion-pdf-bar :count="seleccionados.length" :loading="descargandoPdfs"
      @descargar="descargarSeleccionados()" @limpiar="seleccionados = []" />
    <section class="invoice-preview-wrapper">

      <!-- ═══ Resumen Cards ═══ -->
      <div class="fac__resumen invoice-actions">
        <div
          v-for="item in dataResumen"
          :key="item.icon"
          v-if="item.visible"
          class="fac__resumen-card"
          :class="'fac__resumen-card--' + item.variant"
        >
          <div class="fac__resumen-icon" :class="'fac__resumen-icon--' + item.variant">
            <i :class="item.icon"></i>
          </div>
          <div class="fac__resumen-body">
            <div class="fac__resumen-valor">
              <span v-if="item.valor.euro != undefined && item.valor.euro != '0,00'">{{ item.valor.euro }} &euro;</span>
              <br v-if="item.valor.euro != undefined && item.valor.euro != '0,00' && item.valor.libra != '0,00'" />
              <span v-if="item.valor.libra != undefined && item.valor.libra != '0,00'">&pound; {{ item.valor.libra }}</span>
              <span v-if="item.valor.euro == undefined">{{ item.valor }}</span>
            </div>
            <div class="fac__resumen-label">{{ item.nombre }}</div>
          </div>
        </div>
      </div>

      <!-- ═══ Contenido principal ═══ -->
      <div class="fac__main invoice-actions">

        <!-- Filtros -->
        <div class="fac__filters">
          <div class="fac__filter-item">
            <label class="fac__filter-label">Pagado</label>
            <v-select v-model="pagadoSelect" :options="['Todos', 'Sin Pagar', 'Pagado']" :clearable="false"
              placeholder="Seleccionar" class="fac__filter-select" />
          </div>
          <div class="fac__filter-item">
            <label class="fac__filter-label">Categoria</label>
            <v-select v-model="categoriaSelect" :options="categorias" label="nombre" :clearable="false"
              placeholder="Seleccionar" class="fac__filter-select" />
          </div>
          <div class="fac__filter-item">
            <label class="fac__filter-label">Desde</label>
            <div class="fac__date-wrap">
              <flat-pickr v-model="fechaDesdeSelect" class="form-control fac__date-input" />
              <button class="fac__date-clear" @click="fechaDesdeSelect = ''" title="Limpiar">
                <i class="fa-solid fa-xmark"></i>
              </button>
            </div>
          </div>
          <div class="fac__filter-item">
            <label class="fac__filter-label">Hasta</label>
            <div class="fac__date-wrap">
              <flat-pickr v-model="fechaHastaSelect" class="form-control fac__date-input" />
              <button class="fac__date-clear" @click="fechaHastaSelect = ''" title="Limpiar">
                <i class="fa-solid fa-xmark"></i>
              </button>
            </div>
          </div>
          <div class="fac__filter-item">
            <label class="fac__filter-label">Empresa</label>
            <v-select v-model="empresaSelect" :options="empresas" label="nombre" :clearable="false"
              placeholder="Seleccionar" class="fac__filter-select" />
          </div>
          <div class="fac__filter-item">
            <label class="fac__filter-label">Cliente</label>
            <v-select v-model="clienteSelect" :options="clients" label="nombre" :clearable="false"
              placeholder="Seleccionar" class="fac__filter-select" />
          </div>

          <div class="fac__filter-buttons">
            <button class="fac__btn-fab" @click="openModalNew()" v-b-tooltip.hover.v-success title="Crear nueva factura">
              <i class="fa-solid fa-plus"></i>
            </button>
            <button class="fac__btn-icon" @click="downloadExcell()" v-b-tooltip.hover title="Descargar Excel">
              <i class="fa-solid fa-file-excel"></i>
            </button>
            <button class="fac__btn fac__btn--outline" @click="editarPrecios()">
              <i class="fa-solid fa-tags"></i> Precios
            </button>
          </div>
        </div>

        <!-- Buscador -->
        <div class="fac__search">
          <i class="fa-solid fa-magnifying-glass fac__search-icon"></i>
          <input type="text" class="fac__search-input" placeholder="Buscar factura..." v-model="buscar" />
        </div>

        <!-- Tabla -->
        <div class="fac__table-card">
          <div class="fac__tabla-scroll">
            <b-table
              :items="facturasBusqueda"
              :fields="columnasTable"
              class="fac__table"
              no-border-collapse
              sort-icon-left
              @sort-changed="sortChanged"
              ref="table"
              sort-by="fecha"
              :sort-desc="true"
              :tbody-tr-class="rowClass"
              hover
            >
              <template #head(sel)>
                <b-form-checkbox :checked="todosSeleccionados" @change="seleccionarTodos" />
              </template>
              <template #cell(sel)="data">
                <b-form-checkbox v-if="tienePdf(data.item)" v-model="seleccionados" :value="data.item.id" />
              </template>

              <template #cell(options)="data">
                <div class="fac__actions">
                  <span @click="printInvoice(data.item.id, data)"
                    v-if="data.item.verifactu != null && data.item.verifactu != ''" class="fac__action fac__action--print"
                    v-b-tooltip.hover title="Imprimir factura">
                    <i v-if="data.item.categoria != 'Draft'" class="fa-solid fa-print"></i>
                  </span>
                  <span @click="editFactura(data.item.id)"
                    v-if="data.item.verifactu == null || data.item.verifactu == '' || data.item.verifactu == '1'" class="fac__action fac__action--edit"
                    v-b-tooltip.hover title="Editar factura">
                    <i class="fa-solid fa-pen-to-square"></i>
                  </span>
                  <span v-if="data.item.categoria != 'Rectificativa'"
                    @click="editFactura(data.item.id + '-c')" class="fac__action fac__action--copy"
                    v-b-tooltip.hover :title="data.item.categoria != 'Draft' ? 'Copiar factura' : 'Convertir a factura'">
                    <i v-if="data.item.categoria != 'Draft'" class="fa-solid fa-copy"></i>
                    <span class="fac__action--draft" v-else>
                      <i class="fa-solid fa-arrow-right"></i>
                      <i class="fa-solid fa-file-invoice-dollar"></i>
                    </span>
                  </span>
                  <span @click="downloadTrackingFactura(data.item.codigo)"
                    class="fac__action fac__action--tracking" v-if="data.item.codigo[0] == 'F'"
                    v-b-tooltip.hover title="Descargar tracking">
                    <i class="fa-solid fa-truck-fast"></i>
                  </span>
                  <span v-if="data.item.categoria != 'Draft' && data.item.categoria != 'Rectificativa' && !data.item.permisoBorrar"
                    @click="editFactura(data.item.id + '-r')" class="fac__action fac__action--rectificativa"
                    v-b-tooltip.hover title="Crear rectificativa">
                    <i class="fa-solid fa-hand-holding-dollar"></i>
                  </span>
                  <span @click="deleteFactura(data.item.id, data.item.codigo)"
                    class="fac__action fac__action--delete"
                    v-if="data.item.permisoBorrar || data.item.categoria == 'Draft'"
                    v-b-tooltip.hover.v-danger title="Eliminar factura">
                    <i class="fa-solid fa-trash"></i>
                  </span>
                </div>
              </template>

              <template #cell(pagado)="data">
                <div v-if="data.item.categoria != 'Draft'">
                  <span v-if="!data.item.pagado" class="fac__pagado fac__pagado--no" @click="clickPagado(true, data.item.id)">
                    <i class="fa-solid fa-xmark"></i>
                  </span>
                  <span v-else class="fac__pagado fac__pagado--si">
                    <span @click="clickPagado(false, data.item.id)">
                      <i class="fa-solid fa-check"></i> {{ data.item.fechaPagado }}
                    </span>
                    <span class="fac__pagado-edit" @click="editarFechaPagado(data.item)">
                      <i class="fa-solid fa-pen-to-square"></i>
                    </span>
                  </span>
                </div>
              </template>

              <template #cell(optVerifactu)="data">
                <span v-if="data.item.permisoVerifactu && (data.item.verifactu == null || data.item.verifactu == '') && data.item.categoria != 'Draft'"
                  @click="generarVerifactu(data.item)" class="fac__action fac__action--print"
                  v-b-tooltip.hover title="Generar Verifactu">
                  <i class="fa-solid fa-qrcode"></i>
                </span>
              </template>
            </b-table>
          </div>
          <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10"></div>
        </div>
      </div>

      <b-row v-if="invoiceData" class="invoice-preview">
        <b-col cols="12" xl="12" md="12">
          <b-card no-body class="invoice-preview-card">
            <div
              v-if="invoiceData.datosVerifactu && invoiceData.datosVerifactu.qr"
              style="
                position: absolute;
                top: -20px;
                right: 20px;
                z-index: 999;
                background-color: red;
                color: red;
              "
            >
              <img
                :src="'data:image/png;base64,' + invoiceData.datosVerifactu.qr"
                alt="QR Factura"
                style="
                  max-width: 210px;
                  max-height: 210px;
                  background-color: red;
                  color: red;
                "
              />
            </div>

            <div class="factura-header">
              <b-card-body class="invoice-padding pb-0">
                <div
                  class="mt-md-0 mt-2"
                  style="
                    position: absolute;
                    top: 20px;
                    left: 50%;
                    display: flex;
                    transform: translateX(-50%);
                    flex-direction: column;
                    align-items: center;
                  "
                >
                  <h4 class="invoice-title">
                    <span v-if="invoiceData.idCategoria != 10">Factura: </span>
                    <span v-else>Factura Rectificativa: </span>

                    <span class="invoice-number">{{ invoiceData.codigo }}</span>
                  </h4>
                  <div class="invoice-date-wrapper2">
                    <p class="invoice-date-title2">
                      Fecha: {{ invoiceData.fecha }}
                    </p>
                  </div>
                </div>

                <div
                  class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0"
                >
                  <div>
                    <div class="logo-wrapper">
                      <img
                        :src="invoiceData.empresa.image"
                        style="max-width: 200px; margin-top: 20px"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </b-card-body>

              <hr class="factura-header-separator" />

              <!-- Invoice Client & Payment Details -->
              <b-card-body
                v-if="invoiceData.cliente"
                class="invoice-padding pt-1"
              >
                <b-row class="invoice-spacing">
                  <!-- Col: Invoice To -->
                  <b-col cols="4" xl="4" class="p-0">
                    <b-card-text class="mb-25">
                      <h6 class="mb-2">
                        <b></b>
                      </h6>
                      <br />
                      <b>{{ invoiceData.empresa.nombre }}</b>
                    </b-card-text>
                    <b-card-text class="mb-0">
                      {{ invoiceData.empresa.direccion }}
                    </b-card-text>
                    <b-card-text class="mb-0">
                      {{ invoiceData.empresa.direccion2 }}
                    </b-card-text>
                    <b-card-text class="mb-25">
                      {{ invoiceData.empresa.direccion3 }}
                    </b-card-text>
                    <b-card-text class="mb-0">
                      {{ invoiceData.empresa.cif }}
                    </b-card-text>
                  </b-col>

                  <!-- Col: Payment Details -->
                  <b-col
                    xl="4"
                    cols="4"
                    class="p-0 mt-xl-0 mt-2 d-flex justify-content-xl-end ml-auto"
                  >
                    <div v-if="invoiceData.direccionEnvio != null">
                      <h6 class="mt-2 mb-0.5">
                        <b>Dirección Envío:</b>
                      </h6>
                      <h6 class="mb-25">
                        <b>{{ invoiceData.direccionEnvio.nombre }}</b>
                      </h6>
                      <b-card-text class="mb-0">
                        {{ invoiceData.direccionEnvio.tlf }}
                      </b-card-text>
                      <b-card-text class="mb-0">
                        {{ invoiceData.direccionEnvio.direccion }}
                      </b-card-text>
                      <b-card-text class="mb-0">
                        {{ invoiceData.direccionEnvio.cp }},
                        {{ invoiceData.direccionEnvio.provincia }}
                      </b-card-text>
                      <b-card-text class="mb-0">
                        {{ invoiceData.direccionEnvio.ciudad }},
                        {{ invoiceData.direccionEnvio.pais }}
                      </b-card-text>
                      <b-card-text class="mb-25">
                        {{ invoiceData.direccionEnvio.cif }}
                      </b-card-text>
                    </div>
                  </b-col>

                  <!-- Col: Payment Details -->
                  <b-col
                    style="z-index: 999999"
                    xl="4"
                    cols="4"
                    class="p-0 mt-xl-0 mt-2 d-flex justify-content-xl-end ml-auto"
                  >
                    <div>
                      <h6 class="mt-2" style="z-index: 999999">
                        <b v-if="invoiceData.direccionEnvio == null"
                          >Dirección facturación y envío:</b
                        >
                        <b v-else>Dirección facturación:</b>
                      </h6>
                      <h6 class="mb-25">
                        <b>{{ invoiceData.cliente.nombre }}</b>
                      </h6>
                      <b-card-text class="mb-25">
                        {{ invoiceData.cliente.tlf }}
                      </b-card-text>
                      <b-card-text class="mb-0">
                        {{ invoiceData.cliente.direccion }}
                      </b-card-text>
                      <b-card-text class="mb-0">
                        {{ invoiceData.cliente.cp }},
                        {{ invoiceData.cliente.provincia }}
                      </b-card-text>
                      <b-card-text class="mb-0">
                        {{ invoiceData.cliente.ciudad }},
                        {{ invoiceData.cliente.pais }}
                      </b-card-text>
                      <b-card-text class="mb-25">
                        {{ invoiceData.cliente.email }}
                      </b-card-text>
                      <b-card-text class="mb-25">
                        {{ invoiceData.cliente.cif }}
                      </b-card-text>
                    </div>
                  </b-col>
                </b-row>
              </b-card-body>
            </div>

            <main class="mt-5">
              <!-- Invoice Description: Table -->
              <b-table-lite
                responsive
                :items="invoiceData.items"
                :fields="columnas"
                class="tabla-factura-preview"
                :class="classMargenTablaPreview"
              >
                <template #head(precio)="data">
                  <div class="align-right">
                    <span>{{ data.label.toUpperCase() }}</span>
                  </div>
                </template>

                <template #head(cantidad)="data">
                  <div class="align-right">
                    <span>{{ data.label.toUpperCase() }}</span>
                  </div>
                </template>

                <template #head(total)="data">
                  <div class="align-right">
                    <span>{{ data.label.toUpperCase() }}</span>
                  </div>
                </template>

                <template #cell(descripcion)="data">
                  <p style="white-space: pre-line; margin: 0">
                    {{ data.item.descripcion }}
                  </p>
                </template>
                <template #cell(precio)="data">
                  <p
                    style="white-space: pre-line; margin: 0; text-align: right"
                  >
                    {{ data.item.precio }}
                  </p>
                </template>
                <template #cell(cantidad)="data">
                  <p
                    style="white-space: pre-line; margin: 0; text-align: right"
                  >
                    {{ data.item.cantidad }}
                  </p>
                </template>
                <template #cell(total)="data">
                  <p
                    style="white-space: pre-line; margin: 0; text-align: right"
                  >
                    {{ data.item.total }}
                  </p>
                </template>
                <template #custom-foot>
                  <b-tr>
                    <b-td :colspan="columnas.length" class="td-footer-factura">
              <div class="container-footer">
                <div class="flex-container">
                  <div class="left">
                    <div>
                      <h6 class="mb-2">
                        <b>Detalles del pago:</b>
                      </h6>
                      <table>
                        <tbody v-if="invoiceData.empresa.id == 2">
                          <tr>
                            <td class="pr-1">Banco:</td>
                            <td>Sabadell</td>
                          </tr>
                          <tr>
                            <td class="pr-1">IBAN:</td>
                            <td>ES89 0081 5107 1700 0161 7268</td>
                          </tr>
                          <tr>
                            <td class="pr-1">SWIFT code:</td>
                            <td>BSABESBBXXX</td>
                          </tr>
                        </tbody>
                        <tbody v-if="invoiceData.empresa.id == 1">
                          <tr>
                            <td class="pr-1">Bank:</td>
                            <td>HSBC</td>
                          </tr>
                          <tr>
                            <td class="pr-1">Short Code:</td>
                            <td>40-02-26</td>
                          </tr>
                          <tr>
                            <td class="pr-1">Bank Account:</td>
                            <td>02770253</td>
                          </tr>
                          <tr>
                            <td class="pr-1">IBAN:</td>
                            <td>GB90 HBUK 4002 2602 7702 53</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="right">
                    <div class="invoice-total-wrapper">
                      <div
                        class="invoice-total-item"
                        v-if="
                          invoiceData.descuentototal != 0 ||
                          invoiceData.retencion != 0 ||
                          invoiceData.iva > 0 ||
                          invoiceData.shipping != 0
                        "
                      >
                        <p class="invoice-total-title">Subtotal:</p>
                        <p class="invoice-total-amount">
                          {{ invoiceData.subtotal }}
                        </p>
                      </div>
                      <div
                        class="invoice-total-item"
                        v-if="invoiceData.descuentototal != 0"
                      >
                        <p class="invoice-total-title">Descuento:</p>
                        <p class="invoice-total-amount">
                          -{{ invoiceData.descuentototal }}
                        </p>
                      </div>
                      <div
                        class="invoice-total-item"
                        v-if="invoiceData.retencion != 0"
                      >
                        <p class="invoice-total-title">
                          Retencion {{ invoiceData.retencion }}%:
                        </p>
                        <p class="invoice-total-amount">
                          -{{ invoiceData.retenciontotal }}
                        </p>
                      </div>
                      <div
                        class="invoice-total-item"
                        v-if="invoiceData.iva > 0"
                      >
                        <p class="invoice-total-title">
                          Iva {{ invoiceData.iva }}%:
                        </p>
                        <p class="invoice-total-amount">
                          {{ invoiceData.ivatotal }}
                        </p>
                      </div>
                      <div
                        class="invoice-total-item"
                        v-if="invoiceData.shipping != 0"
                      >
                        <p class="invoice-total-title">Shipping:</p>
                        <p class="invoice-total-amount">
                          {{ invoiceData.shipping }}
                        </p>
                      </div>
                      <hr class="my-50" />
                      <div class="invoice-total-item">
                        <p class="invoice-total-title">Total:</p>
                        <p class="invoice-total-amount">
                          {{ invoiceData.total }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Spacer -->
              <hr
                class="invoice-spacing"
                v-if="invoiceData.notas != null && invoiceData.notas.length > 0"
              />

              <!-- Note -->
              <b-card-body
                class="invoice-padding pt-0"
                v-if="invoiceData.notas != null && invoiceData.notas.length > 0"
              >
                <span class="font-weight-bold">Notas: </span>
                <span>{{ invoiceData.notas }}</span>
              </b-card-body>
                    </b-td>
                  </b-tr>
                </template>
              </b-table-lite>
            </main>
          </b-card>
        </b-col>
      </b-row>
    </section>

    <b-modal
      id="modal-fecha-pagado-factura"
      ref="modalFechaPagadoFactura"
      title="Seleccionar nueva fecha de pago"
      ok-title="Guardar"
      cancel-title="Cancelar"
      @ok="guardarFechaPagado"
      @shown="focusInputFecha"
      centered
      size="sm"
      ok-variant="primary"
      cancel-variant="outline-secondary"
    >
      <b-form-group label="Fecha" label-for="input-fecha-factura">
        <input
          id="input-fecha-factura"
          class="form-control"
          type="date"
          v-model="nuevaFechaPagado"
          required
        />
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import axios from "@axios";
import SeleccionPdfBar from "@/components/SeleccionPdfBar.vue";
import { descargarZip, nombreArchivo } from "@/libs/descargarZip";
import { ref, onUnmounted } from "@vue/composition-api";
/*import VueApexCharts from 'vue-apexcharts'*/
import {
  BTable,
  BFormCheckbox,
  BFormInput,
  BFormGroup,
  BModal,
  BCardText,
  BCardBody,
  BCard,
  BRow,
  BCol,
} from "bootstrap-vue";
import BCardCode from "@core/components/b-card-code";
import { $themeColors } from "@themeConfig";
import { useTimeout } from "@vueuse/shared";
import vSelect from "vue-select";
import { forEach } from "postcss-rtl/lib/affected-props";
import flatPickr from "vue-flatpickr-component";
import { Exception } from "tiff.js";
import { t } from "@/@core/libs/i18n/utils";

export default {
  components: {
    SeleccionPdfBar,
    BCardCode,
    BFormCheckbox,
    BTable,
    BFormInput,
    BFormGroup,
    BCardText,
    BCardBody,
    BCard,
    BRow,
    BCol,
    vSelect,
    flatPickr,
  },
  data() {
    return {
      nuevaFechaPagado: '',
      facturaActualPagado: null,
      seleccionados: [],
      descargandoPdfs: false,
      columnasTable: [
        { key: "sel", label: "", sortable: false, thStyle: { width: "32px" } },
        {
          key: "options",
          label: "",
          sortable: false,
          thStyle: { width: "12%" },
        },
        {
          key: "codigo",
          label: "Codigo",
          sortable: true,
        },
        {
          key: "fecha",
          label: "Fecha",
          sortable: true,
        },
        {
          key: "categoria",
          label: "Categoria",
          sortable: true,
        },
        {
          key: "nombreEmpresa",
          label: "Empresa",
          sortable: true,
        },
        {
          key: "cliente",
          label: "Cliente",
          sortable: true,
        },
        {
          key: "ivatotal",
          label: "Iva",
          sortable: true,
        },
        {
          key: "total",
          label: "Total",
          sortable: true,
        },
        {
          key: "pagado",
          label: "Pagado",
          sortable: true,
        },
        {
          key: "optVerifactu",
          label: "QR",
          sortable: false,
          thStyle: { width: "1%" },
        },
      ],
      buscar: "",
      countItemView: 30,
      nextScrollItemView: 20,
      defaultItemView: 30,
      lastSort: null,
      facturasBusqueda: [],
      listadoFacturas: [],
      fechaDesdeSelect: "",
      fechaHastaSelect: "",
      categorias: [],
      categoriaSelect: null,
      pagadoSelect: "Todos",
      empresaSelect: "",
      clienteSelect: "",
      clients: [],
      empresas: [],
      dataResumen: [
        {
          visible: true,
          icon: "fa-solid fa-file-invoice-dollar",
          nombre: "Facturas",
          valor: 22,
          variant: "primary",
        },
        {
          visible: true,
          icon: "fa-solid fa-dog",
          nombre: "Iva",
          valor: 22,
          variant: "warning",
        },
        {
          visible: true,
          icon: "fa-solid fa-money-bill-transfer",
          nombre: "Pendiente",
          valor: 22,
          variant: "danger",
        },
        {
          visible: true,
          icon: "fa-solid fa-hand-holding-dollar",
          nombre: "Cobrado",
          valor: 22,
          variant: "success",
        },
        {
          visible: true,
          icon: "fa-solid fa-money-bill",
          nombre: "Total",
          valor: 22,
          variant: "info",
        },
        {
          visible: false,
          icon: "fa-solid fa-dollar-sign",
          nombre: "RRP",
          valor: 0,
          variant: "success",
        },
      ],
      invoiceData: {
        empresa: { image: "" },
        datosVerifactu: { qr: "" },
      },
      columnas: [
        {
          key: "descripcion",
          label: "Descripcion",
          thStyle: { width: "90%", textAlign: "left" },
        },
        {
          key: "precio",
          label: "precio",
          thStyle: { width: "10%" },
        },
      ],
      classMargenTablaPreview: "tabla-margen-0",
      listadoProductos: [],
    };
  },
  computed: {
    todosSeleccionados() {
      const ids = this.facturasBusqueda.filter(this.tienePdf).map((f) => f.id);
      return ids.length > 0 && ids.every((id) => this.seleccionados.includes(id));
    },
  },
  methods: {
    // Mismo criterio que el boton de imprimir
    tienePdf(item) {
      return item.verifactu != null && item.verifactu != "" && item.categoria != "Draft";
    },
    seleccionarTodos(marcar) {
      this.seleccionados = marcar ? this.facturasBusqueda.filter(this.tienePdf).map((f) => f.id) : [];
    },
    async descargarSeleccionados() {
      this.descargandoPdfs = true;
      const archivos = [];
      let fallidos = 0;
      try {
        // Secuencial: cada PDF se genera en el backend
        for (const id of this.seleccionados) {
          const item = this.listadoFacturas.find((f) => f.id === id);
          if (!item) continue;
          try {
            const response = await axios.get("/finanzas/factura/pdf/" + id, { responseType: "blob" });
            archivos.push({ nombre: nombreArchivo(item.codigo || "factura_" + id) + ".pdf", contenido: response.data });
          } catch (e) {
            console.error("Error obteniendo PDF de la factura " + id + ":", e);
            fallidos++;
          }
        }
        if (archivos.length) {
          await descargarZip("facturas_" + new Date().toISOString().slice(0, 10) + ".zip", archivos);
          this.seleccionados = [];
        }
        if (fallidos) {
          this.$swal({ icon: "warning", title: fallidos + " PDF no se pudieron incluir en el zip", toast: true,
            position: "top-end", showConfirmButton: false, timer: 4000, timerProgressBar: true });
        }
      } catch (e) {
        console.error("Error generando zip:", e);
        this.$swal({ icon: "error", title: "Error al generar el zip", toast: true,
          position: "top-end", showConfirmButton: false, timer: 3000, timerProgressBar: true });
      } finally {
        this.descargandoPdfs = false;
      }
    },
    loadItems() {
      function ponerMoneda(total, moneda) {
        if (moneda == "€") return total + "" + moneda;
        else return moneda + "" + total;
      }

      axios.post("/uso", { seccion: "factura" });

      axios
        .get("/finanzas/facturas")
        .then((response) => {
          return response.data;
        })
        .then((res) => {
          this.listadoFacturas = res.map((x) => {
            return {
              ...x,
              pagadoTexto: x.pagado ? "Si" : "No",
              total: ponerMoneda(x.total, x.moneda),
            };
          });

          this.listadoFacturas = this.listadoFacturas.sort(
            (a, b) => b.id - a.id
          );

          this.agregarPermisoBorrar();
          this.agregarPermisoVerifactu();

          if (this.fechaDesdeSelect == "")
            this.fechaDesdeSelect = new Date().getFullYear() + "-01-01";

          this.facturasBusqueda = this.listadoFacturas;
          this.buscarFuncion();

          //console.log(this.facturasBusqueda);
        });

      axios
        .get("/finanzas/categorias")
        .then((response) => {
          return response.data;
        })
        .then((res) => {
          this.categorias = res;
          this.categorias.unshift({ id: 0, nombre: "Todas" });
          if (this.categoriaSelect == null)
            this.categoriaSelect = this.categorias[0];

          this.categorias.push({ id: 10, nombre: "Rectificativa" });
        });

      axios
        .get("/finanzas/cliente")
        .then((response) => {
          return response.data;
        })
        .then((res) => {
          this.clients = res;
          this.clients.unshift({ id: 0, nombre: "Todos" });
          if (this.clienteSelect == "") this.clienteSelect = this.clients[0];
        });

      axios
        .get("/finanzas/empresas")
        .then((response) => {
          return response.data;
        })
        .then((res) => {
          this.empresas = res;
          this.empresas.unshift({ id: 0, nombre: "Todas" });
          if (this.empresaSelect == "") this.empresaSelect = this.empresas[0];
        });

      axios
        .get("/shopify/products")
        .then((response) => {
          return response.data;
        })
        .then((res) => {
          this.listadoProductos = res.flatMap((product) =>
            product.variants.map((variant) => ({
              sku: variant.sku,
              price: variant.price,
            }))
          );
        });
    },
    agregarPermisoBorrar() {
      const ultimosIds = {};

      // Encontrar el ID más alto para cada categoría
      this.listadoFacturas.forEach((elemento) => {
        const { id, idCategoria } = elemento;
        if (!ultimosIds[idCategoria] || id > ultimosIds[idCategoria]) {
          ultimosIds[idCategoria] = id;
        }
      });

      // Añadir el atributo permisoBorrar al último elemento de cada categoría
      this.listadoFacturas.forEach((elemento) => {
        const { id, idCategoria } = elemento;
        if (idCategoria === 1)
          //Quitamos el poder borrar de fabricacion de momento (falta cambiar en el backend, la resta de cantidad facturada y sumarla a cantidad)
          return;

        if (elemento.verifactu != null && elemento.verifactu != "")
          elemento.permisoBorrar = false;
        else elemento.permisoBorrar = id === ultimosIds[idCategoria];
      });
    },
    agregarPermisoVerifactu() {
      const primerosIds = {};

      // Encontrar la primera factura (por año y categoría) que no se haya procesado
      this.listadoFacturas.forEach((elemento) => {
        const { id, idCategoria, verifactu, fecha } = elemento;
        const anio = new Date(fecha).getFullYear();

        // Solo si no está procesada
        if (!verifactu) {
          const clave = `${idCategoria}-${anio}`;

          // Guardar el id más bajo de esa categoría + año
          if (!primerosIds[clave] || id < primerosIds[clave]) {
            primerosIds[clave] = id;
          }
        }
      });

      const facturasMap = new Map(this.facturasBusqueda.map((f) => [f.id, f]));

      this.listadoFacturas.forEach((elemento) => {
        const { id, idCategoria, fecha } = elemento;
        const anio = new Date(fecha).getFullYear();
        const clave = `${idCategoria}-${anio}`;

        const permiso = id === primerosIds[clave];
        elemento.permisoVerifactu = permiso;

        const itemBusqueda = facturasMap.get(id);
        if (itemBusqueda) {
          itemBusqueda.permisoVerifactu = permiso;
        }
      });
    },
    openModalNew() {
      this.$router.push("/factura-edit");
    },
    editarPrecios() {
      this.$router.push("/precios-sku");
    },
    printInvoice(id, data) {
      // El PDF se genera en el backend (como en /shopify-invoice-pdf) para
      // evitar los cortes de pagina del print del navegador
      return axios
        .get("/finanzas/factura/pdf/" + id, { responseType: "blob" })
        .then((response) => {
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/pdf" })
          );
          const link = document.createElement("a");
          link.href = url;
          link.download =
            ((data && data.item && data.item.codigo) || "factura") + ".pdf";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setTimeout(() => window.URL.revokeObjectURL(url), 60000);
        })
        .catch(async (execption) => {
          let mensaje = "Error generando el PDF";
          try {
            mensaje = await execption.response.data.text();
          } catch (e) {}
          this.$swal({
            icon: "error",
            title: mensaje,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },
    loadMore() {
      this.countItemView += this.nextScrollItemView;
      this.buscarFuncion();
    },
    sortChanged(e) {
      this.lastSort = e;
      this.buscarFuncion();
    },
    downloadExcell() {
      var csv =
        "Codigo;Fecha;Categoria;Empresa;Cliente;IVA;Total;Pagado" + "\n";

      this.facturasBusqueda.forEach((factura) => {
        let pagado = "";
        if (factura.pagado) pagado = factura.fechaPagado;

        csv +=
          factura.codigo +
          ";" +
          factura.fecha +
          ";" +
          factura.categoria +
          ";" +
          factura.nombreEmpresa +
          ";" +
          factura.cliente +
          ";" +
          factura.ivatotal +
          ";" +
          factura.total +
          ";" +
          pagado +
          "\n";
      });

      var encodedUri = encodeURI(csv);
      var link = document.createElement("a");
      link.setAttribute("href", "data:text/csv;charset=utf-8," + encodedUri);
      link.setAttribute("download", "facturas.csv");
      document.body.appendChild(link);
      link.click();
    },
    clickPagado(estado, id) {
      axios
        .put("/finanzas/factura/pagado", { pagado: estado, id })
        .then((response) => {
          return response.data;
        })
        .then((res) => {
          this.facturasBusqueda.forEach((item) => {
            if (item.id == id) item.fechaPagado = res;
          });

          this.listadoFacturas.forEach((item) => {
            if (item.id == id) item.fechaPagado = res;
          });

          this.facturasBusqueda.forEach((item) => {
            if (item.id == id) item.pagado = estado;
          });
        })
        .catch((execption) => {});
    },
    generarVerifactu(dato) {
      axios
        .post("/finanzas/verifactu", { id: dato.id, codigo: dato.codigo })
        .then((response) => {
          return response.data;
        })
        .then((res) => {
          dato.verifactu = res.url;

          this.agregarPermisoVerifactu();
        })
        .catch((execption) => {
          this.$swal({
            icon: "danger",
            title:
              "Se ha producido un error al generar el QR. (Revisar el servidor)",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },
    buscarFuncion(items = this.listadoFacturas) {
      let auxSorting = JSON.parse(JSON.stringify(items));

      if (this.lastSort != null) {
        if (this.lastSort.sortDesc)
          auxSorting.sort(
            (a, b) => b[this.lastSort.sortBy] - a[this.lastSort.sortBy]
          );
        else
          auxSorting.sort(
            (a, b) => a[this.lastSort.sortBy] - b[this.lastSort.sortBy]
          );
      }

      items = auxSorting;

      this.facturasBusqueda = [];

      this.facturasBusqueda = items.filter((factura) => {
        const pagadoCondicion =
          this.pagadoSelect === "Todos" ||
          (this.pagadoSelect === "Sin Pagar" && factura.pagado === 0) ||
          (this.pagadoSelect === "Pagado" && factura.pagado === 1);

        const categoriaCondicion =
          this.categoriaSelect.id === 0 ||
          this.categoriaSelect.id === factura.idCategoria;

        const empresaCondicion =
          this.empresaSelect.id === 0 ||
          this.empresaSelect.id === factura.idEmpresa;
        const clienteCondicion =
          this.clienteSelect.id === 0 ||
          this.clienteSelect.id === factura.idCliente;

        const textoCondicion = factura.codigo
          .toLowerCase()
          .includes(this.buscar.toLowerCase());

        const fechaDesdeCondicion =
          !this.fechaDesdeSelect ||
          new Date(factura.fecha) >= new Date(this.fechaDesdeSelect);
        const fechaHastaCondicion =
          !this.fechaHastaSelect ||
          new Date(factura.fecha) <= new Date(this.fechaHastaSelect);

        let pruebas = true;

        if (factura.idCategoria == 7 && true) {
          //true para que no salga en deploy
          pruebas = false;
        }

        return (
          pagadoCondicion &&
          categoriaCondicion &&
          textoCondicion &&
          empresaCondicion &&
          clienteCondicion &&
          fechaDesdeCondicion &&
          fechaHastaCondicion &&
          pruebas
        );
      });

      this.calcularResumen();
    },
    buscarFuncion2(items = this.listadoFacturas) {
      let auxSorting = JSON.parse(JSON.stringify(items));

      if (this.lastSort != null) {
        if (this.lastSort.sortDesc)
          auxSorting.sort(
            (a, b) => b[this.lastSort.sortBy] - a[this.lastSort.sortBy]
          );
        else
          auxSorting.sort(
            (a, b) => a[this.lastSort.sortBy] - b[this.lastSort.sortBy]
          );

        if (this.lastSort.sortBy == "sku") {
          if (this.lastSort.sortDesc)
            auxSorting.sort((a, b) => b.sku.localeCompare(a.sku));
          else auxSorting.sort((a, b) => a.sku.localeCompare(b.sku));
        }
      }

      items = auxSorting;

      this.facturasBusqueda = [];

      if (this.buscar == "") {
        this.facturasBusqueda = items.slice(0, this.countItemView);
      } else {
        let facturasEncontradas = [];
        items.forEach((factura) => {
          if (
            factura.codigo.toLowerCase().includes(this.buscar.toLowerCase())
          ) {
            facturasEncontradas.push(factura);
          }
        });

        this.facturasBusqueda = facturasEncontradas.slice(
          0,
          this.countItemView
        );
      }
    },
    recalcularDatos() {
      this.cargarColumnas();

      this.buscarFuncion();
    },
    previewFactura(id) {
      this.$router.push("/factura-preview/" + id);
    },
    editFactura(id) {
      this.$router.push("/factura-edit/" + id);
    },
    deleteFactura(id, codigo) {
      this.$swal({
        title: "Estas seguro que quieres borrar la factura: " + codigo,
        icon: "error",
        showCancelButton: true,
        //html: `<input type="text" id="motivo" class="swal2-input" placeholder="Motivo">`,
        confirmButtonText: "Si, borrar",
        cancelButtonText: "No",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .delete("/finanzas/factura/" + id, { data: { codigo } })
            .then((response) => {
              return response.data;
            })
            .then((res) => {
              //this.listadoFacturas

              this.$swal({
                icon: "success",
                title: "La factura se ha borrado correctamente: " + codigo,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });

              this.listadoFacturas = this.listadoFacturas.filter(
                (item) => item.id !== id
              );
              this.facturasBusqueda = this.facturasBusqueda.filter(
                (item) => item.id !== id
              );
              this.calcularResumen();
              this.agregarPermisoBorrar();
              this.agregarPermisoVerifactu();
              this.buscarFuncion();
            })
            .catch((execption) => {
              //console.log(execption);
              this.$swal({
                icon: "danger",
                title: "Se ha producido un error al borrar la factura.",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            });
        }
      });
    },
    calcularResumen() {
      let facturas = 0;
      let ivaEuro = 0;
      let pendienteDineroEuro = 0;
      let cobradoDineroEuro = 0;
      let totalEuro = 0;
      let ivaLibra = 0;
      let pendienteDineroLibra = 0;
      let cobradoDineroLibra = 0;
      let totalLibra = 0;

      this.facturasBusqueda.forEach((item) => {
        if (item.categoria == "Draft") return;
        facturas++;

        let importeTotal = parseFloat(item.total.replace(item.moneda, ""));

        if (item.moneda === "€") {
          ivaEuro += parseFloat(item.ivatotal.replace("€", ""));
          if (item.pagado == 0) {
            pendienteDineroEuro += importeTotal;
          } else {
            cobradoDineroEuro += importeTotal;
          }
          totalEuro += importeTotal;
        } else if (item.moneda === "£") {
          ivaLibra += parseFloat(item.ivatotal.replace("£", ""));
          if (item.pagado == 0) {
            pendienteDineroLibra += importeTotal;
          } else {
            cobradoDineroLibra += importeTotal;
          }
          totalLibra += importeTotal;
        }
      });

      this.dataResumen[0].valor = facturas;
      this.dataResumen[1].valor = {
        euro: ivaEuro
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,")
          .replace(/\./g, "temp")
          .replace(/,/g, ".")
          .replace(/temp/g, ","),
        libra: ivaLibra
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,")
          .replace(/\./g, "temp")
          .replace(/,/g, ".")
          .replace(/temp/g, ","),
      };
      this.dataResumen[2].valor = {
        euro: pendienteDineroEuro
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,")
          .replace(/\./g, "temp")
          .replace(/,/g, ".")
          .replace(/temp/g, ","),
        libra: pendienteDineroLibra
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,")
          .replace(/\./g, "temp")
          .replace(/,/g, ".")
          .replace(/temp/g, ","),
      };
      this.dataResumen[3].valor = {
        euro: cobradoDineroEuro
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,")
          .replace(/\./g, "temp")
          .replace(/,/g, ".")
          .replace(/temp/g, ","),
        libra: cobradoDineroLibra
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,")
          .replace(/\./g, "temp")
          .replace(/,/g, ".")
          .replace(/temp/g, ","),
      };
      this.dataResumen[4].valor = {
        euro: totalEuro
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,")
          .replace(/\./g, "temp")
          .replace(/,/g, ".")
          .replace(/temp/g, ","),
        libra: totalLibra
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,")
          .replace(/\./g, "temp")
          .replace(/,/g, ".")
          .replace(/temp/g, ","),
      };

      this.calcularRRP();
    },
    editarFechaPagado(data) {
      this.facturaActualPagado = data;
      this.nuevaFechaPagado = data.fechaPagado || new Date().toISOString().substr(0, 10);
      this.$refs.modalFechaPagadoFactura.show();
    },
    focusInputFecha() {
      this.$nextTick(() => {
        const el = document.getElementById('input-fecha-factura');
        if (!el) return;
        if (typeof el.showPicker === 'function') {
          el.showPicker();
          return;
        }
        el.focus();
        el.click();
      });
    },
    guardarFechaPagado() {
      axios
        .put("/finanzas/factura/fechapagado", {
          fechaPagado: this.nuevaFechaPagado,
          id: this.facturaActualPagado.id,
        })
        .then((response) => response.data)
        .then((res) => {
          this.facturasBusqueda.forEach((item) => {
            if (item.id == this.facturaActualPagado.id) item.fechaPagado = this.nuevaFechaPagado;
          });
          this.listadoFacturas.forEach((item) => {
            if (item.id == this.facturaActualPagado.id) item.fechaPagado = this.nuevaFechaPagado;
          });
          this.calcularResumen();
        });
    },
    calcularRRP() {
      if (this.categoriaSelect.nombre == "Fabricación") {
        this.dataResumen[5].visible = true;
        //console.log(this.facturasBusqueda);
        const facturasId = this.facturasBusqueda.map((item) => item.id);

        if (facturasId.length == 0) {
          this.dataResumen[5].valor = 0;
          return;
        }

        axios
          .post("/finanzas/facturas/lineas", { facturasId })
          .then((response) => {
            return response.data;
          })
          .then((res) => {
            const findPriceBySku = (sku) => {
              const variant = this.listadoProductos.find((v) => v.sku === sku);
              return variant ? Number(variant.price) : null;
            };

            let totalPrice = 0;

            res.forEach((linea) => {
              let priceSku = findPriceBySku(linea.sku);

              if (priceSku == null) {
                //console.log(linea.sku);
              } else totalPrice += priceSku * linea.cantidad;
            });

            this.dataResumen[5].valor =
              totalPrice
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                .replace(/\./g, "temp")
                .replace(/,/g, ".")
                .replace(/temp/g, ",") + " €";
          });
      } else this.dataResumen[5].visible = false;
    },
    guardarFiltro() {
      let datos = {
        pagado: this.pagadoSelect,
        categoria: this.categoriaSelect,
        desde: this.fechaDesdeSelect,
        hasta: this.fechaHastaSelect,
        empresa: this.empresaSelect,
        cliente: this.clienteSelect,
        buscar: this.buscar,
      };

      const date = new Date();
      let hours = 12;
      date.setTime(date.getTime() + hours * 60 * 60 * 1000);
      const expires = "expires=" + date.toUTCString();
      document.cookie =
        "facturas" + "=" + JSON.stringify(datos) + ";" + expires + ";path=/";
    },
    cargarFiltro() {
      let datos = null;

      const nameEQ = "facturas" + "=";
      const cookiesArray = document.cookie.split(";");
      for (let i = 0; i < cookiesArray.length; i++) {
        let cookie = cookiesArray[i];
        while (cookie.charAt(0) == " ")
          cookie = cookie.substring(1, cookie.length);
        if (cookie.indexOf(nameEQ) == 0) {
          datos = JSON.parse(cookie.substring(nameEQ.length, cookie.length));
        }
      }

      if (datos != null) {
        this.pagadoSelect = datos.pagado;
        this.categoriaSelect = datos.categoria;
        this.fechaDesdeSelect = datos.desde;
        this.fechaHastaSelect = datos.hasta;
        this.empresaSelect = datos.empresa;
        this.clienteSelect = datos.cliente;
        this.buscar = datos.buscar;
      }
    },
    downloadTrackingFactura(data) {
      axios
        .get("/finanzas/factura/tracking/" + data)
        .then((response) => {
          return response.data;
        })
        .then((res) => {
          //console.log(res);
          if (res && res.length) {
            let csv =
              "Numero Pedido;SKU;Cantidad;Codigo Factura;Pais Destino;Compañia envio;Tracking;Fecha Tracking\r\n";
            res.forEach((item) => {
              csv += `${item.orderNumber};${item.sku};${item.cantidad};${
                item.codigoFactura
              };${item.country_sent};${item.company_tracking};${
                item.tracking
              };${item.fechaTracking.split("T")[0]}\r\n`;
            });

            // codifica también los saltos de línea y caracteres especiales
            const encoded = encodeURIComponent(csv);

            const link = document.createElement("a");
            link.href = "data:text/csv;charset=utf-8," + encoded;
            link.download = `Tracking_Factura_${data}.csv`;
            document.body.appendChild(link);
            link.click();
            link.remove();
          } else {
            this.$swal({
              icon: "warning",
              title: "No hay tracking disponible para esta factura.",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          }
        });
    },
    rowClass(item) {
      if (!item) return "";

      if (item.categoria === "Draft") {
        return "fila-draft";
      } else if (item.categoria === "Rectificativa") {
        return "fila-rectificativa";
      }

      return "";
    },
  },
  mounted() {
    this.loadItems();
    this.cargarFiltro();
  },
  watch: {
    buscar() {
      if (this.buscar == "") this.countItemView = this.defaultItemView;
      this.buscarFuncion();
      this.guardarFiltro();
    },
    pagadoSelect() {
      this.buscarFuncion();
      this.guardarFiltro();
    },
    categoriaSelect() {
      this.buscarFuncion();
      this.guardarFiltro();
    },
    clienteSelect() {
      this.buscarFuncion();
      this.guardarFiltro();
    },
    empresaSelect() {
      this.buscarFuncion();
      this.guardarFiltro();
    },
    fechaDesdeSelect() {
      this.buscarFuncion();
      this.guardarFiltro();
    },
    fechaHastaSelect() {
      this.buscarFuncion();
      this.guardarFiltro();
    },
  },
};
</script>

<style lang="scss">
@import "../@core/scss/vue/libs/chart-apex.scss";
@import "../@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style scoped>
/* ═══ Resumen ═══ */
.fac__resumen {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 14px;
  justify-content: center;
}

.fac__resumen-card {
  flex: 1;
  min-width: 180px;
  background: #fff;
  border-radius: 14px;
  padding: 20px 22px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  transition: transform 0.2s, box-shadow 0.2s;
  border-left: none;
}
.fac__resumen-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}
.fac__resumen-card--primary { background: linear-gradient(135deg, #faf9ff 0%, #fff 100%); }
.fac__resumen-card--warning { background: linear-gradient(135deg, #fffcf7 0%, #fff 100%); }
.fac__resumen-card--danger  { background: linear-gradient(135deg, #fff8f8 0%, #fff 100%); }
.fac__resumen-card--success { background: linear-gradient(135deg, #f6fff6 0%, #fff 100%); }
.fac__resumen-card--info    { background: linear-gradient(135deg, #f5fdff 0%, #fff 100%); }

.fac__resumen-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
}
.fac__resumen-icon--primary { background: #eeedfd; color: #7367f0; }
.fac__resumen-icon--warning { background: #fff3e0; color: #ff9f43; }
.fac__resumen-icon--danger { background: #fce4e4; color: #ea5455; }
.fac__resumen-icon--success { background: #e8fce8; color: #28c76f; }
.fac__resumen-icon--info { background: #e0f4ff; color: #00cfe8; }

.fac__resumen-valor {
  font-size: 19px;
  font-weight: 600;
  color: #3b4253;
  line-height: 1.2;
}

.fac__resumen-label {
  font-size: 12px;
  font-weight: 500;
  color: #8a8e99;
  margin-top: 3px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

/* ═══ Main container ═══ */
.fac__main {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* ═══ Botones ═══ */
.fac__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 10px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.fac__btn--outline {
  background: transparent;
  color: #7367f0;
  border: 1px solid #7367f0;
}
.fac__btn--outline:hover {
  background: #7367f0;
  color: #fff;
}

.fac__btn-fab {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: none;
  background: linear-gradient(135deg, #28c76f 0%, #48da89 100%);
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(40, 199, 111, 0.4);
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fac__btn-fab:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(40, 199, 111, 0.5);
}

/* ═══ Filtros ═══ */
.fac__filters {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  background: #fff;
  border-radius: 14px;
  padding: 16px 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  flex-wrap: wrap;
}

.fac__filter-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 130px;
}

.fac__filter-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #8a8e99;
  margin-bottom: 0;
}

.fac__filter-buttons {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  margin-left: auto;
  padding-bottom: 2px;
}

.fac__btn-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid #dfe3e8;
  background: #fff;
  color: #6e6b7b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.2s;
}
.fac__btn-icon:hover {
  background: #7367f0;
  color: #fff;
  border-color: #7367f0;
}

.fac__date-wrap {
  display: flex;
  align-items: center;
  gap: 4px;
}

.fac__date-clear {
  background: none;
  border: none;
  color: #b0b5c0;
  cursor: pointer;
  font-size: 13px;
  padding: 4px;
  transition: color 0.2s;
}
.fac__date-clear:hover {
  color: #ea5455;
}

/* ═══ Buscador ═══ */
.fac__search {
  position: relative;
}

.fac__search-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #b0b5c0;
  font-size: 14px;
  z-index: 1;
}

.fac__search-input {
  width: 100%;
  padding: 12px 16px 12px 42px;
  border: 1px solid #e9ecf1;
  border-radius: 14px;
  font-size: 14px;
  color: #3b4253;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.2s;
  outline: none;
}
.fac__search-input:focus {
  border-color: #7367f0;
  box-shadow: 0 0 0 3px rgba(115, 103, 240, 0.12);
}
.fac__search-input::placeholder {
  color: #c0c4cc;
}

/* ═══ Tabla card ═══ */
.fac__table-card {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.fac__tabla-scroll {
  width: 100%;
  overflow-x: auto;
}

/* ═══ Acciones tabla ═══ */
.fac__actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.fac__action {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s;
  font-size: 13px;
}

.fac__action--print { color: #7367f0; background: #eeedfd; }
.fac__action--print:hover { background: #7367f0; color: #fff; }

.fac__action--edit { color: #28c76f; background: #e8fce8; }
.fac__action--edit:hover { background: #28c76f; color: #fff; }

.fac__action--copy { color: #ff9f43; background: #fff3e0; }
.fac__action--copy:hover { background: #ff9f43; color: #fff; }

.fac__action--draft { color: #805f21; font-size: 11px; }

.fac__action--tracking { color: #a855f7; background: #f3e8ff; }
.fac__action--tracking:hover { background: #a855f7; color: #fff; }

.fac__action--rectificativa { color: #6c757d; background: #f0f1f4; }
.fac__action--rectificativa:hover { background: #6c757d; color: #fff; }

.fac__action--delete { color: #ea5455; background: #fce4e4; }
.fac__action--delete:hover { background: #ea5455; color: #fff; }

/* ═══ Pagado ═══ */
.fac__pagado {
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.fac__pagado--no {
  color: #ea5455;
  background: #fce4e4;
  padding: 3px 10px;
  border-radius: 20px;
}

.fac__pagado--si {
  color: #28c76f;
}

.fac__pagado-edit {
  cursor: pointer;
  margin-left: 8px;
  color: #8a8e99;
  transition: color 0.15s;
}
.fac__pagado-edit:hover {
  color: #7367f0;
}
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "@core/scss/base/pages/app-invoice.scss";
</style>

<style lang="scss">
/* ═══ Tabla global styles ═══ */
.fac__table {
  margin-bottom: 0;

  thead th {
    background: #f8f9fb !important;
    border-bottom: 2px solid #e9ecf1 !important;
    border-top: none !important;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #8a8e99;
    padding: 12px 14px;
    white-space: nowrap;
  }

  tbody td {
    padding: 10px 14px;
    vertical-align: middle;
    border-bottom: 1px solid #f0f1f4 !important;
    border-top: none !important;
    font-size: 13px;
    color: #5e5873;
    white-space: nowrap;
  }

  tbody tr {
    transition: background 0.15s;
    background: transparent !important;

    &:hover {
      background: #f9f8ff !important;
    }
  }

  &.b-table-striped tbody tr:nth-of-type(odd) {
    background: transparent !important;
  }
}

.fac__table .fila-draft {
  background-color: #fffbeb !important;
  &:hover { background-color: #fef3cd !important; }
}

.fac__table .fila-rectificativa {
  background-color: #fff0f0 !important;
  &:hover { background-color: #ffe5e5 !important; }
}

/* ═══ Print / Invoice preview (preserved) ═══ */
.factura-header-separator {
  margin: 0 2.5rem 1rem 2.5rem;
  border: 0;
  border-top: 1px solid #e9ecf1;
}

.flex-container {
  display: flex;
}

.container-footer {
  margin-top: 40px;
}

.left {
  margin-left: 30px;
  flex: 1;
}

.right {
  margin-left: auto;
  margin-right: 28px;
}

.invoice-total-amount {
  margin-left: 10px;
}

.align-right {
  text-align: right !important;
}

.invoice-preview {
  display: none;
}

.tabla-margen-0 { margin-top: 0px !important; }
.tabla-margen-30 { margin-top: 30px !important; }
.tabla-margen-35 { margin-top: 35px !important; }
.tabla-margen-70 { margin-top: 70px !important; }
.tabla-margen-n25 { margin-top: 120px !important; }
.tabla-margen-115 { margin-top: -20px !important; }
.tabla-margen-n20 { margin-top: -20px; }

.invoice-actions2 {
  display: none;
}

/* ═══ Dark mode ═══ */
.dark-layout {
  .fac__resumen-card {
    background: #242424 !important;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2) !important;
  }
  .fac__resumen-card--primary,
  .fac__resumen-card--warning,
  .fac__resumen-card--danger,
  .fac__resumen-card--success,
  .fac__resumen-card--info {
    background: #242424 !important;
  }

  .fac__resumen-valor { color: #d0d2d6 !important; }
  .fac__resumen-label { color: #b4b7bd !important; }

  .fac__filters {
    background: #242424 !important;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2) !important;
  }

  .fac__filter-label { color: #b4b7bd !important; }

  .fac__search-input {
    background: #242424 !important;
    border-color: #333 !important;
    color: #d0d2d6 !important;

    &::placeholder { color: #676d7d !important; }
  }

  .fac__table-card {
    background: #242424 !important;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2) !important;
  }

  .fac__btn-icon {
    background: #242424 !important;
    border-color: #333 !important;
    color: #b4b7bd !important;
  }

  .fac__table {
    thead th { background: #2e2e2e !important; border-bottom-color: #333 !important; color: #b4b7bd !important; }
    tbody td { color: #d0d2d6 !important; border-bottom-color: #333 !important; }
    tbody tr:hover { background: #2e2e2e !important; }
  }

  .fac__table .fila-draft {
    background-color: rgba(255, 159, 67, 0.15) !important;
    &:hover { background-color: rgba(255, 159, 67, 0.25) !important; }
  }

  .fac__table .fila-rectificativa {
    background-color: rgba(234, 84, 85, 0.15) !important;
    &:hover { background-color: rgba(234, 84, 85, 0.25) !important; }
  }

  .fac__action--print { background: #2a2640 !important; }
  .fac__action--edit { background: #1e3a2a !important; }
  .fac__action--copy { background: #3a2e1e !important; }
  .fac__action--tracking { background: #2a1e3a !important; }
  .fac__action--rectificativa { background: #333 !important; }
  .fac__action--delete { background: #3a1e1e !important; }

  .fac__pagado--no {
    background: #3a1e1e !important;
    color: #ea5455 !important;
  }
}

@media print {
  .tooltip,
  .b-tooltip {
    display: none !important;
  }

  .main-menu,
  .navbar-container {
    display: none;
  }

  .invoice-preview {
    display: block;
  }

  .align-right {
    text-align: right !important;
  }

  .tabla-factura-preview thead tr th {
    background-color: transparent;
    height: 470px;
    position: relative;
  }

  .tabla-factura-preview thead tr th div {
    position: absolute;
    bottom: 0;
  }

  .invoice-preview-card {
    top: 0px !important;
  }

  .invoice-preview-wrapper {
    margin-top: -80px !important;
  }

  .factura-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 450px;
    padding: 10px;
    font-size: 16px;
    z-index: 9999;
    background-color: #fff;
  }

  .tabla-factura-preview thead tr th {
    border-top: none !important;
    border-bottom: none !important;
  }

  /* El pie (banco + totales) va dentro del tfoot de la tabla para que,
     al saltar de página, respete el hueco que reserva el thead bajo la
     cabecera fija. Sin table-row-group el tfoot se repetiría en cada página. */
  .tabla-factura-preview tfoot {
    display: table-row-group;
  }

  .tabla-factura-preview .td-footer-factura {
    border: none !important;
    background-color: transparent !important;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
            > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    .invoice-actions {
      display: none;
    }

    .tabla-factura-preview tr:nth-child(even) td {
      background-color: #f1f1f1 !important;
      color: black;
    }

    .tabla-factura-preview tr:nth-child(odd) td {
      color: black;
    }
  }
}
</style>